<div class="login-form-container">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 logo-container">

        <div class="">
          <div class="logo-wrapper">
            <div class="logo">
              <div>
                <img *ngIf="configService.themeConfig && configService.themeConfig.LogoUrl" [src]="configService.themeConfig.LogoUrl" alt="Site Logo">
              </div>
            </div>
            <div class="logo-content" *ngIf="configService.themeConfig">
              <h1 *ngIf="configService.themeConfig.Heading">{{'userLogin.logoContent' | translate}}</h1>
              <h2 *ngIf="configService.themeConfig.SubHeading">{{configService.themeConfig.SubHeading}}</h2>
              <div class="small-description">
                <strong *ngIf="configService.themeConfig.TagLine">{{configService.themeConfig.TagLine}}</strong><br>
                <!-- <span *ngIf="configService.themeConfig.Description">{{smallDescription}}</span> -->
                <span *ngIf="langCode === 'en-US' || !langCode">{{configService.themeConfig.Description}}</span>
                <span *ngIf="langCode === 'es-ES'">{{configService.themeConfig.DescSpanish}}</span>
                <span *ngIf="langCode === 'pt-PT'">{{configService.themeConfig.DescPortugese}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 login-form">
        <div id="login" class="form-container">
          <!-- <div class="logo-svaas">
            <img *ngIf="configService.themeConfig.svaslogoUrl" [src]="configService.themeConfig.svaslogoUrl" alt="" width="200">
          </div> -->
          <div id="login-row" class="justify-content-center align-items-center">
            <div id="login-box">
              <div id="login-column" class="login-column-c">
                <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
                  <p class="text-center login-title">{{'userLogin.loginForm.title' | translate}}</p>
                  <label for="username" class="text-info">{{'userLogin.loginForm.email' | translate}}<span class="error">*</span></label><br>
                  <input type="email" maxlength="125" class="form-control" formControlName="email"
                    (keydown.space)="$event.preventDefault()" (blur)="onClickOutside(true, 'email')"
                    (click)="onClickOutside(false, 'email')">
                  <div *ngIf="f?.email.invalid && (f?.email.touched || f?.email.dirty)">
                    <div class="alert alert-danger" *ngIf="f.email.errors.required">{{'userLogin.loginForm.errorMail1' | translate}}</div>
                    <div class="alert alert-danger" *ngIf="f?.email.errors?.minlength">{{'users.createUser.emailError2' | translate}}</div>
                    <div class="alert alert-danger" *ngIf="f?.email.errors?.maxlength">{{'users.createUser.emailError3' | translate}}</div>
                    <div class="alert alert-danger" *ngIf="f?.email.errors?.pattern && inValidEmail">{{'users.createUser.emailError4' | translate}}</div>
                  </div>
                  <label for="password" class="text-info">{{'userLogin.loginForm.password' | translate}}<span class="error">*</span></label><br>
                  <input type="password" maxlength="21" class="form-control" formControlName="password"
                      (keydown.space)="$event.preventDefault()">
                    <div *ngIf="f?.password.invalid && (f?.password.dirty || f?.password.touched)" class="alert alert-danger">
                      <div *ngIf="f.password.errors.required">{{'userLogin.loginForm.errorPwd' | translate}}
                      </div>
                      <div *ngIf="f?.password.errors?.maxlength ||
                                                      f?.password.errors?.pattern ||
                                                      f?.password.errors?.minlength ||
                                                      loginForm?.get('password').hasError('passwordSameAsUsernameOrEmail')">
                        {{'users.createUser.passError2' | translate}}
                      </div>
                    </div>
                  <div class="captcha-group">
                    <div class="captcha">
                      <img [src]="CaptchaImgUrl" alt="captcha-image" class="captcha-image img-fluid">
                        <div class="refresh-icon"  matTooltip="{{'userLogin.loginForm.toolTip' | translate}}">
                          <mat-icon (click)="resendCaptcha()">refresh</mat-icon>
                        </div>
                    </div>

                    <div class="captcha-input">
                      <label for="captcha" class="text-info">{{'userLogin.loginForm.captcha' | translate}}<span class="error">*</span></label><br>
                      <input type="text" class="form-control" formControlName="captchaText" [ngClass]="{ 'is-invalid': submitted && f.captchaText.errors }">
                      <div *ngIf="submitted && f.captchaText.invalid">
                        <div class="alert alert-danger" *ngIf="f.captchaText.errors.required">{{'userLogin.loginForm.errorCaptcha' | translate}}</div>
                      </div>
                    </div>

                    <div class="remember-me">
                      <mat-checkbox formControlName="rememberMe">{{'userLogin.loginForm.remember' | translate}}</mat-checkbox>
                    </div>
                  </div>

                  <div class="form-group">
                    <div><a routerLink="" tabindex="0" [ngClass]="{'adisabled': disableForgotPass}"
                      (click)="!disableForgotPass ? resetPwd() : ''" (keydown.enter)="!disableForgotPass && resetPwd()"
                      class="no-underline" >{{'userLogin.loginForm.link' | translate}}</a></div>
                    <div>
                      <button type="submit" class="btn-login btn-bg-color" mat-flat-button [disabled]="isValid">
                        <span *ngIf="!loginSpinner">{{'userLogin.loginForm.btn' | translate}}</span>
                        <span *ngIf="loginSpinner"><i class="fa fa-spinner fa-spin fa-1x" aria-hidden="true"></i></span>
                      </button>
                    </div>
                    <div class="privacy-policy"><a routerLink="" tabindex="0" class="privacy-policy-link" (click)="onClickPrivacyPolicy()"
                      (keydown.enter)="onClickPrivacyPolicy()">{{'userLogin.loginForm.privacyPolicy' | translate}}</a></div>
                  </div>
                </form>
              </div>
              <span *ngIf="!lockoutMsg" class="error-message invalid-feedback">{{ loginErrorMessage }}</span>
              <div *ngIf="lockoutMsg" class="alert alert-danger">
                <div>{{ loginErrorMessage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer-copyrights" id="cp">
  <!-- © {{fullyear}} SimpliAssess, All Rights Reserved. -->
  © {{fullyear}} {{'footer.text' | translate}}
</div>

<div class="idle-logout" *ngIf="idleService.showIdealLogoutMessage">
  <div class="message" (clickOutside)="resetIdealLogoutFlag()">{{'userLogin.idleLogoutMsg' | translate}}</div>
</div>

<!--
  SimpliAssess is an online test maker that brings high quality assessments within
  everyone’s reach. It’s an easy-to-use headless assessment platform for educators,
  course administrators and training professionals to conduct online tests and quizzes
  across multiple channels.
-->
